// extracted by mini-css-extract-plugin
export default {"banderole":"BanderoleInfo_banderole__3bEdt","banderoleContainer":"BanderoleInfo_banderoleContainer__36bD2"};